import i18next from "i18next";
// import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import enCustom from "./locales/en.json";
import jaCustom from "./locales/ja.json";

// API key
// const apiKey = "BBDE1rKvh2htO5j4ps17mA";
// const loadPath = `https://api.i18nexus.com/project_resources/translations/{{lng}}.json?api_key=${apiKey}`;

i18next
  // .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "ja", // ngôn ngữ mặc định
    lng: "ja",
    // ns: ["default"],
    // defaultNS: "default",
    supportedLngs: ["ja", "en"], // Japanese, English, Korean
    // backend: {
    //   loadPath: loadPath,
    // },
    resources: {
      en: { translation: enCustom },
      ja: { translation: jaCustom },
    },
  });

i18next.on("languageChanged", (lng) => {
  document.body.classList.remove("font-en", "font-ja");
  if (lng === "en") {
    document.body.classList.add("font-en");
  } else if (lng === "ja") {
    document.body.classList.add("font-ja");
  }
});

export default i18next;
